export default __webpack_public_path__ + "static/media/ridge_connect.99458931.png";